import styled from 'styled-components';
import { COLORS } from '../../../constants/style/color';
import { rem } from '../../../utils/style';

export const LockInfoBox = styled.div`
  background: ${COLORS.LightBlue};
  border: 1px solid ${COLORS.Iris};
  border-radius: ${rem(6)};
  padding: ${rem(12)} ${rem(14)};
  margin-bottom: ${rem(16)};
  display: flex;
  gap: ${rem(10)};
  align-items: flex-start;
`;

export const LockInfoIcon = styled.span`
  color: ${COLORS.Iris};
  font-size: ${rem(20)};
  margin-top: 1px;
  flex-shrink: 0;
`;

export const LockInfoContent = styled.div`
  font-size: ${rem(13)};
  line-height: 1.5;
  color: ${COLORS.Gray};

  strong {
    color: ${COLORS.Black};
  }
`;

export const SectionHeading = styled.div`
  margin-bottom: ${rem(8)};

  strong {
    font-size: ${rem(14)};
    color: ${COLORS.Black};
  }
`;
